import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, } from "@material-ui/core";
import Draggable from 'react-draggable';
import { useDispatch } from "react-redux";
import {
    analyseSetFileName
} from '../../actions/analyse.js'
import { useTheme } from "@material-ui/styles"

export default function ModalDialog({ handleClose, open, title, text, yesText, noText }) {
    const dispatch = useDispatch();
    const {theme: {colors}} = useTheme()
    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }
    return (
        <Dialog
            open={open}
            onClose={() => handleClose(null)}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move', color: colors.colorText }} id="draggable-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText style={{ color: colors.colorMutedText}} id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {!!yesText && <Button onClick={() => {
                    handleClose(true);
                    dispatch(analyseSetFileName(""))
                }}
                data-dialog-item='yes' 
                style={{ color: colors.colorBlue1000 }}
                autoFocus>{yesText}</Button>}
                {!!noText && <Button onClick={() => handleClose(false)} style={{ color: colors.colorStatusError }} data-dialog-item='no'>{noText}</Button>}
            </DialogActions>
        </Dialog>
    )
}